module.exports = __webpack_public_path__ + "img/ico-visual-platform_3.84b8fa26.svg";